'use client';

import dynamic from 'next/dynamic';

//* Styles
import BusinessRegistrationTemplateStyle from './style';

//* Components
import NewHeroSection from '../components/NewHeroSection';
const EnvironmentSection = dynamic(
	() => import('@/modules/DiscoverArmenia/LivingInArmenia/components/EnvironmentSection'),
	{
		ssr: false,
		loading: () => <div style={{ minHeight: '30vh' }} />,
	}
);
const NecessaryInformationSection = dynamic(() => import('../components/NecessaryInformationSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const TypesOfBusiness = dynamic(() => import('../components/TypesOfBusiness'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});
const FAQSection = dynamic(() => import('@/sections/FAQSection'), {
	ssr: false,
	loading: () => <div style={{ minHeight: '30vh' }} />,
});

const BusinessRegistrationTemplate = ({ pageData }) => {
	const { content, faqs } = pageData;
	const { hero, electronic_registration, business_type } = content;

	return (
		<BusinessRegistrationTemplateStyle>
			<NewHeroSection {...hero} />

			<EnvironmentSection
				title={electronic_registration.title}
				description={electronic_registration.description}
				items={electronic_registration.items}
				externalLink={electronic_registration?.link}
				externalLinkText={electronic_registration?.link_text}
			/>

			<NecessaryInformationSection
				title={electronic_registration.sub_section_title}
				description={electronic_registration.sub_section_description}
				items={electronic_registration.necessary_facts}
			/>

			<TypesOfBusiness {...business_type} />

			<FAQSection items={faqs} />
		</BusinessRegistrationTemplateStyle>
	);
};

export default BusinessRegistrationTemplate;
